import termsOfUse from '../rw-terms-of-use/components/reducers/terms-of-use';

export default termsOfUse;



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/terms-of-use.reducer.js